import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const IrlAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/irl",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  calculateIrl: async function (cancel = false) {
    const response = await api.request({
      url: "/irl/calculate-irl",
      method: "GET",
      signal: cancel ? cancelApiObject[this.index.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },
}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(IrlAPI)